export default __webpack_public_path__ + "static/media/rest.5db3f55a.svg";